import React, { useEffect, useState } from 'react'
import { Box, Text } from "grommet"
import AgDataTable from '../../common/AgDataTable'
import { useTTUSUserSelective } from '../../../utils/user'
import { deepClone } from '../../../utils/clone'

const HealthStatusServiceAlertEngine = ({ data }) => {
    const [idFilter, setIdFilter] = useState([])
    const userLookup = useTTUSUserSelective(idFilter)
    const tab_col = [
        {
            field: "id",
            headerName: "User ID",
            minWidth: 150,

        },
        {
            field: "emailId",
            headerName: "Email ID",
            minWidth: 150,

        },
        {
            field: "status",
            minWidth: 150,
            headerName: "Status",

        },
    ]

    const [tab_data, settab_data] = useState([])

    useEffect(() => {
        let temp_ids = []
        settab_data(Object.keys(data).sort((a, b) => (data[a].status === 'up') ? 1 : -1).reduce((rowData, rowId) => {

            const row = deepClone(data[rowId])
            const emailId = row.id && userLookup[row.id] ? userLookup[row.id].email : '-'
            temp_ids.push(row.id)

            rowData.push({
                'uniqueId': row.id,
                'id': row.id,
                'emailId': emailId,
                'status': row.status,
                'detailView': {},
            })

            return rowData
        }, []))
        setIdFilter(temp_ids)

        return () => {
            settab_data([])
        }
    }, [data, userLookup])

    return (
        <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">
            <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold"> Alert Engine </Text>

            <AgDataTable
                tab_col={tab_col}
                tab_data={tab_data}
                tableName="HealthStatusServiceAlertEngine"
                tableHeight={700}
            />

        </Box>
    )
}

export default HealthStatusServiceAlertEngine